import { render } from "./logoNav.vue?vue&type=template&id=13de5956&scoped=true"
import script from "./logoNav.vue?vue&type=script&lang=js"
export * from "./logoNav.vue?vue&type=script&lang=js"

import "./logoNav.vue?vue&type=style&index=0&id=13de5956&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13de5956"

export default script